(function () {
  'use strict';

  var modal = document.getElementById('cart-upsell-modal');
  if (!modal) return;

  var configEl = document.getElementById('cart-upsell-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('[cart-upsell] Config parse error', e);
    return;
  }

  var moneyFormat = modal.getAttribute('data-money-format') || '{{amount}} kr';
  var locale = modal.getAttribute('data-locale') || 'sv';

  var upsellsEl = modal.querySelector('[data-cart-upsell-upsells]');
  var justAddedEl = modal.querySelector('[data-cart-upsell-just-added]');
  var checkoutBtn = modal.querySelector('[data-cart-upsell-checkout]');

  // ---------- Subscription detection ----------
  function isSubscriptionActive() {
    var bp = document.querySelector('[id^="bundle-picker-"]');
    return bp && bp.getAttribute('data-purchase-mode') === 'subscription';
  }

  // ---------- Shopify routes ----------
  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // ---------- Cart drawer detection ----------
  function isCartDrawerOpen() {
    var trigger = document.querySelector('a[aria-controls*="cart"][aria-expanded="true"], button[aria-controls*="cart"][aria-expanded="true"]');
    if (trigger) return true;
    if (document.querySelector('cart-drawer[open]')) return true;
    if (document.querySelector('cart-drawer.is-open')) return true;
    if (document.querySelector('#sidebar-cart[aria-hidden="false"]')) return true;
    if (document.querySelector('.Drawer--fromRight[aria-hidden="false"]')) return true;
    return false;
  }

  function forceCloseCartDrawer() {
    var openTriggers = document.querySelectorAll('a[aria-controls*="cart"][aria-expanded="true"], button[aria-controls*="cart"][aria-expanded="true"]');
    openTriggers.forEach(function (trigger) {
      try { trigger.click(); } catch (e) {}
    });

    var closeButtons = document.querySelectorAll('[data-action="close-drawer"][data-drawer-id]');
    closeButtons.forEach(function (btn) {
      try { btn.click(); } catch (e) {}
    });

    var drawers = document.querySelectorAll('cart-drawer[open], cart-drawer.is-open');
    drawers.forEach(function (drawer) {
      if (typeof drawer.close === 'function') {
        try { drawer.close(); } catch (e) {}
      } else {
        drawer.removeAttribute('open');
      }
    });
  }

  function openCartDrawer() {
    var cartTrigger = document.querySelector('a[aria-controls*="cart"], button[aria-controls*="cart"], [data-action="open-drawer"][data-drawer-id*="cart"]');
    if (cartTrigger) {
      try { cartTrigger.click(); } catch (e) {}
    }
  }

  // ---------- Translations ----------
  var T = (window.theme && window.theme.translations && window.theme.translations.cart_upsell) || {};
  function t(key) {
    var leaf = String(key).replace('cart_upsell.', '').split('.').pop();
    return T[leaf] || fallbackStrings[locale][leaf] || fallbackStrings.en[leaf] || leaf;
  }

  var fallbackStrings = {
    sv: {
      headline: 'Behöver du något mer?',
      subtitle: 'Rabatter dras automatiskt i kassan.',
      continue_to_checkout: 'Gå till kassan →',
      no_thanks: 'Nej tack',
      add: 'Lägg till',
      adding: 'Lägger till...',
      added: 'Tillagd',
      close: 'Stäng',
      buy_one_more_for_x: 'Köp 1 till för {{ percent }}% rabatt + fri frakt',
      buy_one_more_for_x_no_shipping: 'Köp 1 till för {{ percent }}% rabatt',
      buy_n_more_for_x: 'Köp {{ qty }} till för {{ percent }}% rabatt + fri frakt',
      max_tier_reached: 'Varje extra burk ger fortfarande {{ percent }}% rabatt',
      free_shipping: 'FRI FRAKT',
      save_percent: 'SPARA {{ percent }}%',
      per_unit: '/burk'
    },
    en: {
      headline: 'Need anything else?',
      subtitle: 'Discounts are added automatically at checkout.',
      continue_to_checkout: 'Continue to checkout →',
      no_thanks: 'No, thank you',
      add: 'Add',
      adding: 'Adding...',
      added: 'Added',
      close: 'Close',
      buy_one_more_for_x: 'Buy 1 more for {{ percent }}% off + free shipping',
      buy_one_more_for_x_no_shipping: 'Buy 1 more for {{ percent }}% off',
      buy_n_more_for_x: 'Buy {{ qty }} more for {{ percent }}% off + free shipping',
      max_tier_reached: 'Each extra jar still gets {{ percent }}% off',
      free_shipping: 'FREE SHIPPING',
      save_percent: 'SAVE {{ percent }}%',
      per_unit: '/jar'
    }
  };

  function tInterpolate(key, vars) {
    var str = t(key);
    Object.keys(vars || {}).forEach(function (k) {
      str = str.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), vars[k]);
    });
    return str;
  }

  // ---------- Money formatting ----------
  function formatMoney(cents) {
    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = num.toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return dollars + decPart;
    }

    var value = cents / 100;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDelimiters(value, 2, ',', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDelimiters(value, 0, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelimiters(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDelimiters(value, 0, '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withDelimiters(value, 2, ' ', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withDelimiters(value, 0, ' '))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDelimiters(value, 2, ' ', '.'));
  }

  // ---------- Cart helpers ----------
  function fetchCart() {
    return fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function getProductQtyInCart(cart) {
    var qty = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === config.product.handle) qty += cart.items[i].quantity;
    }
    return qty;
  }

  function getProductLineFromCart(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === config.product.handle) return cart.items[i];
    }
    return null;
  }

  // ---------- Discount calculation ----------
  function getMaxTierDiscount() {
    var thresholds = config.tier_thresholds || [];
    var max = 0;
    thresholds.forEach(function (t) { if (t.discount > max) max = t.discount; });
    return max;
  }

  function getMaxTierQtyMin() {
    var thresholds = config.tier_thresholds || [];
    var max = 0;
    thresholds.forEach(function (t) { if (t.qty_min > max) max = t.qty_min; });
    return max;
  }

  // ---------- Render ----------
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderJustAdded(cart) {
    var line = getProductLineFromCart(cart);
    if (!line) { justAddedEl.innerHTML = ''; return; }

    var unitPrice = line.final_price || line.price;
    var compareAt = line.original_price || null;
    var hasDiscount = compareAt && compareAt > unitPrice;

    var qtyPrefix = (line.quantity > 1) ? (line.quantity + ' × ') : '';
    var perUnitSuffix = t('per_unit');

    var priceHtml = hasDiscount
      ? '<span class="cart-upsell-modal__added-price-sale">' + formatMoney(unitPrice) + perUnitSuffix + '</span>' +
        '<span class="cart-upsell-modal__added-price-compare">' + formatMoney(compareAt) + perUnitSuffix + '</span>'
      : '<span>' + formatMoney(unitPrice) + perUnitSuffix + '</span>';

    var freeShippingHtml = '';
    if (line.quantity >= 2) {
      freeShippingHtml =
        '<div class="cart-upsell-modal__added-unlock">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true">' +
            '<circle cx="10" cy="10" r="9" fill="#10b981"/>' +
            '<path d="M6 10l3 3 5-6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span>' + escapeHtml(t('free_shipping')) + '</span>' +
        '</div>';
    }

    justAddedEl.innerHTML =
      '<div class="cart-upsell-modal__added-container">' +
        '<div class="cart-upsell-modal__added-line">' +
          '<div class="cart-upsell-modal__added-info">' +
            '<div class="cart-upsell-modal__added-title">' + escapeHtml(qtyPrefix + line.product_title) + '</div>' +
          '</div>' +
          '<div class="cart-upsell-modal__added-price">' + priceHtml + '</div>' +
        '</div>' +
        freeShippingHtml +
      '</div>';
  }

  function renderUpsells(cart) {
    var currentQty = getProductQtyInCart(cart);
    if (currentQty === 0) { upsellsEl.innerHTML = ''; return 0; }

    var thresholds = (config.tier_thresholds || []).slice().sort(function (a, b) { return a.qty_min - b.qty_min; });
    var basePrice = config.product.price;
    var cards = [];
    var maxQtyMin = getMaxTierQtyMin();

    if (currentQty >= maxQtyMin) {
      var maxDiscount = getMaxTierDiscount();
      var discountedPrice = Math.round(basePrice * (1 - maxDiscount / 100));
      cards.push({
        title: tInterpolate('max_tier_reached', { percent: maxDiscount }),
        addQty: 1,
        discount: maxDiscount,
        discountedPrice: discountedPrice,
        compareAt: basePrice,
        badges: ['save_' + maxDiscount]
      });
    } else {
      thresholds.forEach(function (tier) {
        if (tier.qty_min <= currentQty) return;

        var qtyToAdd = tier.qty_min - currentQty;
        var discountedPrice = Math.round(basePrice * (1 - tier.discount / 100));
        var alreadyHasFreeShipping = currentQty >= 2;
        var titleKey;
        if (qtyToAdd === 1) {
          titleKey = alreadyHasFreeShipping ? 'buy_one_more_for_x_no_shipping' : 'buy_one_more_for_x';
        } else {
          titleKey = 'buy_n_more_for_x';
        }

        var cardBadges = ['save_' + tier.discount];
        if (currentQty < 2) cardBadges.push('free_shipping');

        cards.push({
          title: tInterpolate(titleKey, { qty: qtyToAdd, percent: tier.discount }),
          addQty: qtyToAdd,
          discount: tier.discount,
          discountedPrice: discountedPrice,
          compareAt: basePrice,
          badges: cardBadges
        });
      });
    }

    if (cards.length === 0) { upsellsEl.innerHTML = ''; return 0; }

    var html = cards.map(function (card) {
      var badgesHtml = card.badges.map(function (badge) {
        var label;
        if (badge.indexOf('save_') === 0) {
          label = tInterpolate('save_percent', { percent: badge.replace('save_', '') });
        } else if (badge === 'free_shipping') {
          label = t('free_shipping');
        }
        return '<span class="cart-upsell-card__badge">' + escapeHtml(label) + '</span>';
      }).join('');

      return '' +
        '<div class="cart-upsell-section">' +
          '<div class="cart-upsell-section__title">' + escapeHtml(card.title) + '</div>' +
          '<div class="cart-upsell-card">' +
            '<div class="cart-upsell-card__image-wrap">' +
              '<img src="' + escapeHtml(config.product.image) + '" alt="' + escapeHtml(config.product.title) + '" loading="lazy" />' +
            '</div>' +
            '<div class="cart-upsell-card__price">' +
              '<span class="cart-upsell-card__price-sale">' + formatMoney(card.discountedPrice) + t('per_unit') + '</span>' +
              '<span class="cart-upsell-card__price-compare">' + formatMoney(card.compareAt) + t('per_unit') + '</span>' +
            '</div>' +
            '<div class="cart-upsell-card__right">' +
              '<div class="cart-upsell-card__badges">' + badgesHtml + '</div>' +
              '<button type="button" class="cart-upsell-card__btn" data-add-qty="' + card.addQty + '">' +
                escapeHtml(t('add')) +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    upsellsEl.innerHTML = html;
    return cards.length;
  }

  // ---------- Modal show/hide ----------
  var lastFocusedElement = null;

  function showModal(cart) {
    var upsellCount = renderUpsells(cart);
    if (upsellCount === 0) return false;

    forceCloseCartDrawer();
    renderJustAdded(cart);
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { modal.classList.add('is-open'); }, 10);
    checkoutBtn.focus();
    setTimeout(forceCloseCartDrawer, 50);
    setTimeout(forceCloseCartDrawer, 200);

    return true;
  }

  function hideModal() {
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
      refreshCartDrawerHTML();
    }, 200);
  }

  function refreshCartDrawerHTML() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refreshCartDrawer === 'function') {
      try { drawer.refreshCartDrawer(); } catch (e) {
        console.warn('[cart-upsell] refreshCartDrawer failed', e);
      }
    }

    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
      });
  }

  function hideModalAndOpenDrawer() {
    hideModal();
    setTimeout(openCartDrawer, 220);
  }

  // ---------- Add to cart (upsell cards) ----------
  function addQtyToCart(qty, btn) {
    if (!qty || qty < 1) return Promise.resolve();
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }

    return fetch(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Cart-Upsell': '1'
      },
      body: JSON.stringify({
        items: [{
          id: config.product.variant_id,
          quantity: qty,
          properties: { '_source': 'cart-upsell-popup' }
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        return new Promise(function (resolve) { setTimeout(resolve, 400); })
          .then(fetchCart)
          .then(function (cart) {
            renderUpsells(cart);
            renderJustAdded(cart);
            if (btn) { btn.disabled = false; btn.textContent = originalText; }
            setTimeout(function () {
              fetchCart().then(function (latestCart) {
                if (modal.classList.contains('is-open')) {
                  renderUpsells(latestCart);
                  renderJustAdded(latestCart);
                }
              });
            }, 600);
          });
      })
      .catch(function (err) {
        console.error('[cart-upsell] add error', err);
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  }

  // ---------- Event handlers ----------
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-upsell-close]') || e.target.closest('[data-cart-upsell-no-thanks]')) {
      e.preventDefault();
      hideModalAndOpenDrawer();
      return;
    }

    if (e.target.closest('[data-cart-upsell-checkout]')) {
      e.preventDefault();
      window.location.href = shopifyRoot() + 'checkout';
      return;
    }

    var addBtn = e.target.closest('[data-add-qty]');
    if (addBtn) {
      e.preventDefault();
      addQtyToCart(parseInt(addBtn.getAttribute('data-add-qty'), 10), addBtn);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) hideModal();
  });

  // ---------- PDP submit button copy (ATC vs. Go to checkout) ----------
  // Byter huvudformulärets ATC-knapptext beroende på om prenumeration är
  // vald i bundle-picker-blocket: "Gå till kassan" vid subscription, annars
  // orörd (den ursprungliga "Lägg till i varukorgen"-texten från temat).
  function updateSubmitButtonsForMode() {
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]').forEach(function (btn) {
      if (btn.dataset.cartUpsellOriginalText == null) {
        btn.dataset.cartUpsellOriginalText = btn.textContent;
      }
      if (isSubscriptionActive()) {
        btn.textContent = t('continue_to_checkout');
      } else {
        btn.textContent = btn.dataset.cartUpsellOriginalText;
      }
    });
  }

  var bundlePickerEl = document.querySelector('[id^="bundle-picker-"]');
  if (bundlePickerEl) {
    var purchaseModeObserver = new MutationObserver(function () {
      updateSubmitButtonsForMode();
    });
    purchaseModeObserver.observe(bundlePickerEl, {
      attributes: true,
      attributeFilter: ['data-purchase-mode']
    });
  }

  // ---------- PDP ATC form interception ----------
  function doCartAdd(formData) {
    return fetch(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Cart-Upsell': '1'
      },
      body: formData
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (data) {
          throw new Error(data.description || 'Cart add failed');
        });
      }
      return r.json();
    });
  }

  function interceptProductForm(form) {
    if (form.dataset.cartUpsellBound === '1') return;
    form.dataset.cartUpsellBound = '1';

    form.addEventListener('submit', function (e) {
      if (isCartDrawerOpen()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var submitBtn = form.querySelector('button[type="submit"], [name="add"]');
      var originalText = '';
      if (submitBtn) {
        originalText = submitBtn.textContent;
        submitBtn.disabled = true;
      }

      function onSuccess() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }

        if (isSubscriptionActive()) {
          window.location.href = shopifyRoot() + 'checkout';
          return;
        }

        setTimeout(function () {
          fetchCart().then(function (cart) {
            showModal(cart);
            setTimeout(function () {
              fetchCart().then(function (latestCart) {
                if (modal.classList.contains('is-open')) {
                  renderUpsells(latestCart);
                  renderJustAdded(latestCart);
                }
              });
            }, 600);
          });
        }, 400);
      }

      function onFailure(err) {
        console.error('[cart-upsell] form submit error', err);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        alert('Kunde inte lägga till i varukorgen: ' + err.message);
      }

      doCartAdd(formData).then(onSuccess).catch(onFailure);
    }, true);
  }

  function bindAllProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(interceptProductForm);
  }

  bindAllProductForms();
  updateSubmitButtonsForMode();

  var formObserver = new MutationObserver(function (mutations) {
    var hasNewForms = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('form[action*="/cart/add"]')) hasNewForms = true;
        else if (node.querySelector && node.querySelector('form[action*="/cart/add"]')) hasNewForms = true;
      });
    });
    if (hasNewForms) {
      bindAllProductForms();
      updateSubmitButtonsForMode();
    }
  });
  formObserver.observe(document.body, { childList: true, subtree: true });

  // ---------- Fallback: fetch monkey-patch ----------
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    if (!isCartAdd) return originalFetch.apply(this, arguments);

    var fromUpsell = false;
    if (init && init.headers) {
      if (typeof init.headers.get === 'function') {
        fromUpsell = init.headers.get('X-Cart-Upsell') === '1';
      } else {
        fromUpsell = init.headers['X-Cart-Upsell'] === '1';
      }
    }

    var promise = originalFetch.apply(this, arguments);

    if (fromUpsell || isCartDrawerOpen()) return promise;

    return promise.then(function (response) {
      var cloned = response.clone();
      cloned.json().then(function () {
        if (isSubscriptionActive()) {
          setTimeout(function () {
            window.location.href = shopifyRoot() + 'checkout';
          }, 400);
          return;
        }
        setTimeout(function () {
          fetchCart().then(function (cart) {
            showModal(cart);
            setTimeout(function () {
              fetchCart().then(function (latestCart) {
                if (modal.classList.contains('is-open')) {
                  renderUpsells(latestCart);
                  renderJustAdded(latestCart);
                }
              });
            }, 600);
          });
        }, 400);
      }).catch(function () {});
      return response;
    });
  };
})();